export const BIKE_UPGRADES_REQUEST = 'BIKE_UPGRADES_REQUEST';
export const BIKE_UPGRADES_SUCCESS = 'BIKE_UPGRADES_SUCCESS';
export const BIKE_UPGRADES_FAILURE = 'BIKE_UPGRADES_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/bike_upgrades.constants.js